import React from "react";
import { store } from "../../../../../redux/store";
import { heights } from "../../../../../styles/romeu/heights";
import { widths } from "../../../../../styles/romeu/widths";
import { MasterNotificationTypesList } from "./list/list";
import { setNotificationTypes } from "../../../../../redux/reducers/catalog/catalog";
import { resetMasterNotificationTypesList } from "../../../../../redux/reducers/resources/master/notificationType/list";

export class MasterNotificationTypesContainer extends React.Component {
    componentWillUnmount(): void {
        store.dispatch(resetMasterNotificationTypesList());
        store.dispatch(setNotificationTypes([]));
    }

    render(): React.ReactNode {
        return (
            <MasterNotificationTypesList
                widthPopUp={widths.master.default}
                heigthPopUp={heights.master.default}
            />
        );
    }
}
